export interface Field {
    fid?: String;
    label: String,
    type: FieldTypes;
    stage?: Number;
    name: String;
    fields?: Array<Field>
    values?: Array<String>
    options?: Array<any>
    show_in_filterlist?: boolean;
    operatorName?: String,
    operatorLabel?: String,
    remote?: Boolean,
    deleted?: Boolean,
    isEdit?: boolean;
    isNew?: boolean;
    isPreview?: boolean;
    step: number;
    field_type?: String,
    component?: String,
    format?: String,
    field_options?: Array<any>,
}

export interface FilterGroup {
    gid: String;
    label: String,
    deleted?: Boolean,
    filters: Array<Field>
}

export enum FieldTypes {
    Enum = 'enum',
    ObjectID = 'objectid',
    EnumMulti = 'enum_multi',
    Array = 'array',
    String = 'string',
    Text = 'text',
    Number = 'number',
    Date = 'date',
    Time = 'time',
    DateTime = 'datetime'
}